import styled from 'styled-components';

import { IconButton } from 'components/uikit/IconButton/IconButton';
import { ChevronLeftMIcon, ChevronRightMIcon } from 'assets/icons';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const MonthsIconsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Title = styled.div`
  font: var(--font-large-15);
  height: 44px;
  display: flex;
  align-items: center;
  margin-left: 13px;
`;

export const MonthControlButton = styled(IconButton).attrs({
  size: 'm',
  theme: '3',
})`
  & > svg > path {
    fill: var(--color-black);
  }

  &:disabled {
    cursor: not-allowed;

    & > svg > path {
      fill: var(--color-grey-4);
    }
  }
`;

export const PrevMonthButton = styled(MonthControlButton).attrs({ Icon: ChevronLeftMIcon })``;
export const NextMonthButton = styled(MonthControlButton).attrs({ Icon: ChevronRightMIcon })``;
